/* The exercise that closes a chapter.
 *
 * One thing here is deliberate and easy to "fix" wrongly: a wrong answer does
 * not advance anything. The learner stays on the question until they find the
 * right one — the exercise is the chapter's gate, not a score to be recorded.
 */
import { useTranslation } from 'react-i18next';
import { CheckExercise } from '../exercises/CheckExercise';
import { useApp } from '../../state/AppProvider';
import type { Block, NodeDef } from '../../types';

export function CheckBlock({ node, block }: { node: NodeDef; block: Block }) {
  const { t } = useTranslation();
  const { exerciseRound } = useApp();
  const round = exerciseRound[block.id] ?? 1;

  return (
    <>
      <p className="ex-inst">{t('watchHint')}</p>
      <CheckExercise key={`${block.id}:${round}`} node={node} block={block} round={round} />
    </>
  );
}
